import { X } from "react-feather";

import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useLocale } from "lib/hooks/useLocale";
import { eventTypes } from "lib/utils/constants";
import { publishPostMessage } from "lib/utils/helpers";
import { ShoppingCart } from "react-feather";

export const CartHeader = ({ totalItems }: { totalItems?: number }) => {
  const { t } = useLocale();
  const {
    actions: { setCheckoutModal },
  } = useCheckoutContext();
  return (
    <div className="flex w-full items-center justify-between px-6 pb-4 pt-6">
      <div className="flex h-6 items-center gap-2 font-medium text-coal-dark">
        <ShoppingCart className="h-4 w-4" />
        <div className="flex gap-1">
          <span>{t("your_cart")}</span>
          {Boolean(totalItems) && (
            <>
              <span>·</span>
              <span className="font-normal text-coal-light">{t("n_items", { items: totalItems })}</span>
            </>
          )}
        </div>
      </div>
      <button
        onClick={() => {
          setCheckoutModal("NONE");
          publishPostMessage(eventTypes.CLOSE_CART_IFRAME, {});
        }}>
        <X className="h-6 w-6 text-coal-dark" />
      </button>
    </div>
  );
};
